import { render, staticRenderFns } from "./shorturl.vue?vue&type=template&id=12324a88"
import script from "./shorturl.vue?vue&type=script&lang=js"
export * from "./shorturl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports